module.exports = __webpack_public_path__ + "static/media/01.215daec4.jpeg";